import defaultImg from '../../static/images/default-blog-image.jpeg';

const defaultProps = {
  title: '',
  description: '',
  author: {
    '@type': 'Person',
    name: 'Angeli Yuson',
  },
  date: {
    published: '',
    modified: '',
  },
  url: '/',
  image: {
    src: defaultImg,
    width: 400,
    height: 300,
  },
  organization: {
    name: 'Workast Inc',
    url: 'https://www.workast.com/',
    logo: 'https://cdn.workast.io/avatar.png',
    social: [
      'https://www.facebook.com/workastHQ',
      'https://www.twitter.com/workast',
      'https://www.linkedin.com/company/workast',
      'https://www.youtube.com/user/UCNfkUmYb1EnFnDQI3lAAmaw',
    ],
  },
};

export const articlesSchema = (
  image = defaultProps.image,
  title = defaultProps.title,
  url = defaultProps.url,
  description = defaultProps.description,
  author = defaultProps.author,
  organization = defaultProps.organization,
  date = defaultProps.date
) => ({
  '@context': 'http://schema.org',
  '@type': 'BlogPosting',
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': url,
  },
  headline: title,
  description,
  image: {
    '@type': 'ImageObject',
    url: image.src,
    width: image.width,
    height: image.height,
  },
  author: {
    '@type': 'Person',
    name: author,
  },
  publisher: {
    '@type': 'Organization',
    name: organization.name,
    logo: {
      '@type': 'ImageObject',
      url: organization.logo,
      width: 50,
      height: 50,
    },
  },
  datePublished: date.published,
  dateModified: date.modified,
});

export const organizationSchema = (
  organization = defaultProps.organization
) => ({
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: organization.name,
  url: organization.url,
  logo: organization.logo,
  sameAs: organization.social,
});
